import { Subject } from "rxjs/Subject";
import { RemoteServicesProvider } from "./../remote-services/remote-services";
import { LocalstorageProvider } from "./../localstorage/localstorage";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

/*
  Generated class for the LoginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoginProvider {
    expiration = null;
    userId = null;
    userName = null;
    userFirstName = null;
    userFullName = null;
    userAvatar = null;
    isIAMUser = null;
    token = null;
    groups = null;
    posType = null;
    webTrekk = null;

    config = { enablePosCode: false };
    configLoaded: boolean = false;
    loginEvent = new Subject();

    constructor(
        public services: RemoteServicesProvider,
        public storage: LocalstorageProvider,
        public cookieService: CookieService,
    ) {
        this.restoreStorage();
    }

    async doLogin(user: string, password: string) {
        let data: any = await this.services.doLogin(user, password);
        if (data) {
            this.loginEvent.next();

            this.expiration = data.expires;
            this.userId = data.userId;
            this.userName = data.userName;
            this.userFirstName = data.userFirstName;
            this.userFullName = data.userFullName;
            this.isIAMUser = data.isIAMUser;
            this.token = data.access_token;
            this.groups = data.groups;
            this.posType = data.posType;
            this.config = data.config;
            this.webTrekk = data.webTrekk;

            //do not change order
            if (data.userAvatar)
                this.userAvatar = data.userAvatar;
            else
                this.loadUserAvatar();

            if (this.webTrekk) {
                this.cookieService.set("WebTrekk_Cookie", this.webTrekk, 30);
            }
            else{
                this.cookieService.delete("WebTrekk_Cookie");
            }

            return true;
        }

        return false;
    }

    async doLoginSaml(token: string) {
        let data: any = await this.services.doLoginToken(token);
        if (data) {
            this.loginEvent.next();

            this.expiration = data.expires;
            this.userId = data.userId;
            this.userName = data.userName;
            this.userFirstName = data.userFirstName;
            this.userFullName = data.userFullName;
            this.isIAMUser = data.isIAMUser;
            this.token = data.access_token;
            this.groups = data.groups;
            this.posType = data.posType;
            this.config = data.config;
            this.webTrekk = data.webTrekk;

            //do not change order
            if (data.userAvatar)
                this.userAvatar = data.userAvatar;
            else
                this.loadUserAvatar();

            if (this.webTrekk) {
                this.cookieService.set("WebTrekk_Cookie", this.webTrekk, 30);
            }
            else{
                this.cookieService.delete("WebTrekk_Cookie");
            }

            return true;
        }

        return false;
    }

    async loadUserAvatar() {
        var image: any = await this.services.getProfileImage(this.userName, this.token);
        if (image) {
            this.userAvatar = image;
        }
        else {
            this.userAvatar = "assets/imgs/rb_user_placeholder.jpg";;
        }
        this.saveStorage();
    }

    isLogged() {
        if (this.token && this.expiration >= Math.floor(+new Date() / 1000)) {
            return true;
        }
        return false;
    }

    isConfigLoaded() {
        return this.configLoaded;//return sessionStorage.getItem("configLoaded") == "1";
    }

    setConfigLoaded(loaded: boolean = true) {
        return this.configLoaded = loaded;//sessionStorage.setItem("configLoaded", loaded ? "1" : "0");
    }

    logout() {
        this.token = null;
        this.userId = null;
        this.userName = null;
        this.userFirstName = null;
        this.userFullName = null;
        this.userAvatar = null;
        this.isIAMUser = null;
        this.expiration = null;
        this.groups = null;
        this.posType = null;
        this.webTrekk = null;
        this.config = { enablePosCode: false };
        this.storage.clear();
    }

    public saveStorage() {
        this.storage.write(
            "loginData",
            {
                expiration: this.expiration,
                userId: this.userId,
                userName: this.userName,
                userFirstName: this.userFirstName,
                userFullName: this.userFullName,
                userAvatar: this.userAvatar,
                isIAMUser: this.isIAMUser,
                token: this.token,
                groups: this.groups,
                posType: this.posType,
                webTrekk: this.webTrekk,
                config: this.config
            }
        );
    }

    private restoreStorage() {
        try {
            let data = this.storage.read("loginData");
            if (data) {
                this.expiration = data.expiration;
                this.userId = data.userId;
                this.userName = data.userName;
                this.userFirstName = data.userFirstName;
                this.userFullName = data.userFullName;
                this.userAvatar = data.userAvatar;
                this.isIAMUser = data.isIAMUser;
                this.token = data.token;
                this.groups = data.groups;
                this.posType = data.posType;
                this.webTrekk = data.webTrekk;
                this.config = data.config;
            }
        }
        catch (e) {
            console.warn("Login data is corrupted.");
            console.error(e);
        }
    }
}
